import { Route, Routes } from 'react-router';
import './App.css';
import NavBar from './component/navbar';
import 'bootstrap/dist/css/bootstrap.min.css';
import Home from './component/home';
import About from './component/about';
import Pricing from './component/pricing';
// import FooterWithSocialMediaIcons from './component/footer';
import Contacts from './component/contacts';

function App() {
  return (
    <div className="App">
    <NavBar/>
    <Routes>
      <Route path='/' element={<Home/>}></Route>
      <Route path='about/' element={<About/>}></Route>
      <Route path='pricing/' element={<Pricing/>}></Route>
      <Route path='contacts/' element={<Contacts/>}></Route>
    </Routes>
    </div>
  );
}

export default App; 

